import React, { useState, useEffect, useRef } from "react";
import Translator, { __ } from "services/Translator";

import { Link, useParams, useHistory, useLocation } from "react-router-dom";

export default function StakeGameMenu(props) {
  const history = useHistory();
  const location = useLocation();
  const params = useParams();
  const gamesCategory = params.category;
  return (
    <>
      <div className="gameMenuBar">
        <nav className="casino-navbar">
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            className={location.pathname == "/games/top" ? "active nav-item" : "nav-item"}
            to="/games/top"
          >
            <span className="text">{__("Top")}</span>
          </Link>
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            className={location.pathname == "/games/new" ? "active nav-item" : " nav-item"}
            to="/games/new"
          >
            <span className="text">{__("New")}</span>
          </Link>
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            className={location.pathname == "/games/slots" ? "active nav-item" : "nav-item"}
            to="/games/slots"
          >
            <span className="text">{__("Slots")}</span>
          </Link>
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            className={location.pathname == "/games/live-casino" ? "active nav-item" : "nav-item"}
            to="/games/live-casino"
          >
            <span className="text">{__("Live")}</span>
          </Link>
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            className={location.pathname == "/games/crash" ? "active nav-item" : "nav-item"}
            to="/games/crash"
          >
            <span className="text">{__("Crash")}</span>
          </Link>
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            className={location.pathname == "/games/skills" ? "active nav-item" : "nav-item"}
            to="/games/skills"
          >
            <span className="text">{__("Skill")}</span>
          </Link>
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            className={location.pathname == "/games/jackpot" ? "active nav-item" : "nav-item"}
            to="/games/jackpot"
          >
            <span className="text">{__("Jackpot")}</span>
          </Link>
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            className={location.pathname == "/games/table-games" ? "active nav-item" : "nav-item"}
            to="/games/table-games"
          >
            <span className="text">{__("Table Games")}</span>
          </Link>
          {/* <Link
          hreflang={Translator.getSelectedLanguage().code}
          className={location.pathname == "/games/original" ? "active nav-item" : "nav-item"}
          to="/games/original"
        >
          <span className="text">{__("Original")}</span>
        </Link> */}

          {/* <Link
          hreflang={Translator.getSelectedLanguage().code}
          className={location.pathname == "/games/popular" ? "active nav-item" : "nav-item"}
          to="/games/popular"
        >
          <span className="text">{__("Popular")}</span>
        </Link> */}

          <Link
            hreflang={Translator.getSelectedLanguage().code}
            className={location.pathname == "/games/bonus-buy" ? "active nav-item" : "nav-item"}
            to="/games/bonus-buy"
          >
            <span className="text">{__("Bonus Buy")}</span>
          </Link>

          {/* <Link
          hreflang={Translator.getSelectedLanguage().code}
          className={
            location.pathname == "/games/all" ? "active nav-item" : " nav-item"
          }
          to="/games/all"
        >
          <span className="text">{__("All Games")}</span>
        </Link> */}
        </nav>
        <Link className="view-all-btn">View All</Link>
      </div>
    </>
  );
}
